import { useQuery } from '@tanstack/react-query'
import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { CUSTOMER_AGREEMENTS_API } from '../helpers/constants'
import { CustomerAgreementsData } from '../helpers/types'

const getPendingCustomerAgreements = (reference: string): Promise<CustomerAgreementsData> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `${CUSTOMER_AGREEMENTS_API}/${reference}`,
    method: 'GET',
    authenticated: false,
  })
}

export const useCustomerPendingAgreementsQuery = (reference: string) => {
  return useQuery({
    enabled: !!reference,
    queryKey: reactQueryKeys.pendingCustomerAgreements(reference),
    queryFn: () => getPendingCustomerAgreements(reference),
  })
}
